import { render, staticRenderFns } from "./ModelHouseTasks.vue?vue&type=template&id=33af72cd&scoped=true&"
import script from "./ModelHouseTasks.vue?vue&type=script&lang=js&"
export * from "./ModelHouseTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af72cd",
  null
  
)

export default component.exports